// Returns the same action, but with an additional actionAppliedJsDate
// value set on the action object, giving a Javascript date for the time
// the action was called
// A second parameter can supply the date for testing`
export const actionWithAppliedDate = (action, jsDate = new Date()) => {
  action.actionAppliedJsDate = jsDate;
  return action;
};
